import api from "src/services/api";

type Maybe<T> = T | undefined | null;

export type RespuestaTardanzaPayload = {
  alerta_id?: number;
  gestion_id?: number;
  asignacion_id?: number;
  ps_objeto?: string;
  ps_nombre?: string;
  fecha?: string;
  hora_asignada?: string;
  cod_operacion?: string;
  op_cedula?: string;
  op_nombre?: string;
  respuesta_codigo: number;
  respuesta_texto: string;
  origen?: string;
  /** Solo codigo 3 (no voy a asistir). Motivo elegido del catalogo. */
  motivo_ausencia?: string;
  /** Solo codigo 3 con motivo "Otro". Descripcion escrita por el operario. */
  motivo_texto?: string;
  /** Solo codigo 2 (estoy en camino). Valores validos: 10, 20, 30. */
  tiempo_estimado_min?: number;
};

export type RespuestaTardanzaResult = {
  n8nOk: boolean;
};

const N8N_WEBHOOK_URL = process.env.REACT_APP_N8N_WEBHOOK_URL;

const limpiarPayload = (payload: RespuestaTardanzaPayload) => {
  const limpio: Record<string, Maybe<string | number>> = {};
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (typeof value === "string" && value.trim() === "") return;
    limpio[key] = typeof value === "string" ? value.trim() : value;
  });
  return limpio;
};

export const enviarRespuestaTardanza = async (
  payload: RespuestaTardanzaPayload
): Promise<RespuestaTardanzaResult> => {
  const body = limpiarPayload(payload);
  await api.post("gestion_alerta/respuesta_tardanza", body);

  // Si la notificacion vino del motor nuevo de GestionAusencia, notificar tambien a EMSYS
  if (payload.gestion_id) {
    try {
      // El motivo y los minutos viajan aca: hasta 09/2026 este puente los
      // descartaba y la ausencia llegaba a EMSYS sin explicacion.
      await api.post("gestion_alerta/accion_gestion", {
        gestion_id: payload.gestion_id,
        respuesta_codigo: payload.respuesta_codigo,
        ...(payload.motivo_ausencia ? { motivo_ausencia: payload.motivo_ausencia } : {}),
        ...(payload.motivo_texto ? { motivo_texto: payload.motivo_texto } : {}),
        ...(payload.tiempo_estimado_min
          ? { tiempo_estimado_min: payload.tiempo_estimado_min }
          : {}),
      });
    } catch {
      // best-effort: no interrumpe el flujo si falla
    }
  }

  let n8nOk = false;
  if (N8N_WEBHOOK_URL) {
    try {
      const response = await fetch(N8N_WEBHOOK_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      n8nOk = response.ok;
    } catch {
      n8nOk = false;
    }
  }

  return { n8nOk };
};
